import React from 'react';
import * as Styled from './shadow-collapse.styles';
import { Collapse } from '@mui/material';

interface ShadowCollapseProps extends React.PropsWithChildren {
  isOpen: boolean | null;
  handleOpen: () => void;
  commentRef: React.MutableRefObject<HTMLDivElement>;
  collapsedSize?: number;
  shadowColor?: string;
  isClickDisabled?: boolean;
}

const ShadowCollapse: React.FC<ShadowCollapseProps> = ({
  isOpen,
  shadowColor,
  handleOpen,
  commentRef,
  collapsedSize,
  isClickDisabled = false,
  children,
}) => {
  const handleClick = () => {
    if (isClickDisabled || !window.getSelection()?.isCollapsed) return;

    handleOpen();
  };

  return (
    <Styled.Block isOpen={isOpen} shadowColor={shadowColor} isClickDisabled={isClickDisabled}>
      <Collapse
        in={isOpen === null ? true : isOpen}
        onClick={handleClick}
        {...(isOpen !== null ? { collapsedSize } : {})}
      >
        <div ref={commentRef}>{children}</div>
      </Collapse>
    </Styled.Block>
  );
};

export default React.memo(ShadowCollapse);
